import React from "react";
import SVIDivider from './../component/sviDivider';
import { useOutletContext } from "react-router-dom";
import { Rating } from 'react-simple-star-rating'
import { apiReviews } from './../api/apiReviews';
import { exceptionHandler } from './../helper/helperException';


export default function PageRating() {
    const [context] = useOutletContext({});
    const [rating, setRating] = React.useState(0)
    const [disable, setDisable] = React.useState(true);
    const [miniLoading, setMiniLoading] = React.useState(false);
    const isProd = (process.env.NODE_ENV === "production");

    const getDefaultRedirectUrl = () =>
        `/feedback/${context?.fromId ?? context.locationId ?? -1}/${rating ?? 0}`

    function handleSubmit(event) {
        event.preventDefault();

        setDisable(true);
        setMiniLoading(true);

        // Send data
        apiReviews.sendRating({
            ...context,
            rating,
        })
            .then((res) => {
                // Local Log
                if (!isProd) {
                    localStorage.setItem("API/sendRating", JSON.stringify(res?.data));
                    debugger;
                }

                // Redirect URL
                const redirectUrl = res?.data?.redirectUrl
                if (!redirectUrl) {
                    exceptionHandler(null, "pageRating:apiReviews.sendRating: Without redirectUrl", { redirectUrl, context, rating });
                }
                window.location.href = redirectUrl ?? getDefaultRedirectUrl();
            })
            .catch(ex => {
                exceptionHandler(ex, "pageRating:apiReviews.sendRating", { context, rating });
                window.location.href = getDefaultRedirectUrl();
                //setDisable(false);
                //setMiniLoading(false);
            });
    }

    return <>
        <section className="row">
            <div className="col-12">
                <div className="text-center fs-4 text-secondary">
                    {context.isEnglish
                        ? "How likely is it that you would recommend us to a friend or colleague?"
                        : "Quelle est la probabilité que vous nous recommandiez à un ami ou à un collègue?"}
                </div>
            </div>
            <SVIDivider color={context?.brand?.color} />
        </section>
        <form className="row g-3 needs-validation" onSubmit={handleSubmit} noValidate>
            <div className="col-12 text-center py-5">
                <Rating
                    className="text-center"
                    size={60}
                    allowHalfIcon={false}
                    allowHover={true}
                    label
                    transition
                    fillColor='#fabb05'
                    emptyColor='gray'
                    ratingValue={rating ?? 0}
                    onClick={(rate) => {
                        setRating(rate)
                        setDisable(false);
                    }}
                />
            </div>
            <div className="col-12 text-center">
                <button
                    className={`btn text-uppercase btn-${disable ? 'secondary' : context.brand.color}`}
                    type="submit"
                    disabled={disable}>
                    <span>
                        {context.isEnglish ? "Submit" : "Soumettre"}
                        {miniLoading && <i className={"fa fa-spinner fa-spin fa-1x ms-1"}></i>}
                    </span>
                </button>
            </div>
        </form>
    </>

}
